import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M5.46 4.43a10 10 0 0114.73 13.3L17 12.01h3A8 8 0 006.46 6.23l-1-1.8zm13.08 15.14A10 10 0 013.8 6.27L7 11.99H4a8 8 0 0013.54 5.77l1 1.8z"/>
  </SvgIcon>
);